if (!window.__lsScriptsInit) {
  window.__lsScriptsInit = true;

  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    initFaq();
    initProductGallery();
    initVariantPicker();
    initCountUp();
    initTilt();
  });
}

function initReveal() {
  const els = document.querySelectorAll('.ls-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('ls-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.lsDelay || 0;
          setTimeout(() => entry.target.classList.add('ls-visible'), Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => observer.observe(el));
}

function initFaq() {
  document.querySelectorAll('.ls-faq__item').forEach((item) => {
    const btn = item.querySelector('.ls-faq__question');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const isOpen = item.getAttribute('data-open') === 'true';
      item.closest('.ls-faq__list')?.querySelectorAll('.ls-faq__item').forEach((other) => {
        if (other !== item) other.setAttribute('data-open', 'false');
      });
      item.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  });
}

function initProductGallery() {
  const gallery = document.querySelector('[data-ls-gallery]');
  if (!gallery) return;
  const main = gallery.querySelector('[data-ls-gallery-main]');
  const thumbs = gallery.querySelectorAll('[data-ls-gallery-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const full = thumb.dataset.lsFull;
      const alt = thumb.dataset.lsAlt || '';
      if (!full) return;
      main.style.opacity = '0';
      setTimeout(() => {
        main.src = full;
        main.alt = alt;
        main.style.opacity = '1';
      }, 150);
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
}

function initVariantPicker() {
  const form = document.querySelector('[data-ls-product-form]');
  if (!form) return;
  const variantsJsonEl = document.querySelector('[data-ls-variants-json]');
  if (!variantsJsonEl) return;

  let variants;
  try {
    variants = JSON.parse(variantsJsonEl.textContent);
  } catch (e) {
    return;
  }

  const idInput = form.querySelector('input[name="id"]');
  const priceEl = document.querySelector('[data-ls-price-now]');
  const comparePriceEl = document.querySelector('[data-ls-price-was]');
  const submitBtn = form.querySelector('[data-ls-submit]');
  const submitLabel = submitBtn ? submitBtn.querySelector('[data-ls-submit-label]') : null;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant() {
    const selected = {};
    form.querySelectorAll('[data-ls-option]').forEach((el) => {
      if (el.type === 'radio' && !el.checked) return;
      selected[el.dataset.lsOption] = el.value;
    });
    return variants.find((v) =>
      v.options.every((optVal, i) => optVal === selected[String(i)])
    );
  }

  function updateUI() {
    const variant = findVariant();
    if (!variant) {
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = form.dataset.lsUnavailableText || 'Unavailable';
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (variant.featured_image) {
      const gallery = document.querySelector('[data-ls-gallery]');
      const main = gallery ? gallery.querySelector('[data-ls-gallery-main]') : null;
      if (main && main.src !== variant.featured_image) {
        main.style.opacity = '0';
        setTimeout(() => {
          main.src = variant.featured_image;
          main.alt = variant.featured_image_alt || main.alt;
          main.style.opacity = '1';
        }, 150);
      }
      if (gallery) {
        gallery.querySelectorAll('[data-ls-gallery-thumb]').forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.lsFull === variant.featured_image);
        });
      }
    }
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      if (submitLabel) {
        submitLabel.textContent = variant.available
          ? (form.dataset.lsAddText || 'Add to cart')
          : (form.dataset.lsSoldOutText || 'Sold out');
      }
    }
  }

  form.querySelectorAll('[data-ls-option]').forEach((el) => {
    el.addEventListener('change', updateUI);
  });

  updateUI();
}

function initCountUp() {
  const stats = document.querySelectorAll('[data-ls-count-to]');
  if (!stats.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    stats.forEach((el) => (el.textContent = el.dataset.lsCountTo));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        const el = entry.target;
        const target = parseFloat(el.dataset.lsCountTo);
        const suffix = el.dataset.lsSuffix || '';
        const duration = 1400;
        const start = performance.now();
        function tick(now) {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    },
    { threshold: 0.5 }
  );
  stats.forEach((el) => observer.observe(el));
}

function initTilt() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  const els = document.querySelectorAll('[data-ls-tilt]');
  els.forEach((el) => {
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) translateY(-4px)`;
    });
    el.addEventListener('mouseleave', () => {
      el.style.transform = '';
    });
  });
}
